import React, { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { isEnterOrSpace } from "Utils/utils";

import styles from "./styles";

interface Props {
  id: string;
  title?: string;
  headingLevel?: number;
  children?: React.ReactNode;
  expanded?: boolean;
  onClick?: () => void;
  selectedTrail?: string;
  itemCount?: number;
}

const AccordionItem = (props: Props) => {
  const {
    children,
    expanded,
    headingLevel,
    id,
    title,
    onClick,
    selectedTrail,
    itemCount,
  } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles(props);

  const [isExpanded, setIsExpanded] = useState(expanded);

  const buttonId = `${id}--button`;
  const panelId = `${id}--panel`;

  const toggleIsExpanded = () => {
    if (onClick) {
      onClick();
    }
    setIsExpanded((val) => !val);
  };

  // separate useEffect needed to handle closing the accordion when another one is opened
  useEffect(() => {
    setIsExpanded(selectedTrail === title);
  }, [selectedTrail, title]);

  return (
    <div className={classes.accordionItem}>
      <div role="heading" aria-level={headingLevel}>
        <div
          id={buttonId}
          role="button"
          tabIndex={0}
          className={classes.accordionButton}
          aria-label={`${title}. ${itemCount} stops`}
          aria-expanded={isExpanded}
          aria-controls={panelId}
          onClick={toggleIsExpanded}
          onKeyDown={(event) => {
            if (isEnterOrSpace(event)) {
              toggleIsExpanded();
            }
          }}
        >
          <span
            className={`${classes.accordionIcon} ${
              isExpanded ? classes.accordionIconExpanded : ""
            }`}
          />
          {title}
        </div>
      </div>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className={`${classes.accordionPanel} ${
          isExpanded ? "" : classes.hidden
        }`}
      >
        {isExpanded ? children : null}
      </div>
    </div>
  );
};

AccordionItem.defaultProps = {
  children: null,
  headingLevel: 2,
  expanded: false,
  title: "",
  onClick: null,
  selectedTrail: "",
  itemCount: 0,
};

export default AccordionItem;
